// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Rounded Cross icon.
 * @param {IconProps} props - The IconProps for the RoundedCrossIcon component.
 * @returns {ReactElement} The RoundedCrossIcon component.
 */
export const RoundedCrossIcon = (props: IconProps) => {
  const { color = '#D27177', ...rest } = props;
  return (
    <Icon viewBox='0 0 14 14' color={color} id='rounded-cross-icon' {...rest}>
      <path
        d='M7.00034 5.53883L2.87453 1.44422L2.87427 1.44396C2.46822 1.04158 1.8125 1.04129 1.40642 1.44415L1.40622 1.44435C0.998415 1.84937 0.998128 2.50672 1.40642 2.91177L1.40643 2.91179L5.52749 6.99983L1.40583 11.0869L1.40555 11.0872C0.99774 11.4922 0.997453 12.1496 1.40575 12.5546L1.40595 12.5548C1.812 12.9572 2.46771 12.9575 2.87379 12.5546L7.00024 8.46094L11.1257 12.5546L11.1259 12.5548C11.5315 12.9567 12.1861 12.9575 12.5923 12.5561C13.004 12.1527 13.004 11.4903 12.5926 11.0868L8.47305 6.99998L12.5947 2.91286L12.595 2.91258C13.0028 2.50756 13.0031 1.85021 12.5948 1.44516L12.5946 1.44496C12.1886 1.04258 11.5328 1.0423 11.1268 1.44516L7.00034 5.53883Z'
        fill='currentColor'
      />
    </Icon>
  );
};
